import React from 'react';
import { HighlightProps } from 'react-instantsearch-core';
import { Styles } from './styles';
import { Text } from 'atoms/Text/Text';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { connectHighlight } from 'react-instantsearch-dom';
import { useProducts } from 'contexts/ProductsProvider/ProductsProvider';

const ConnectedHighlight: React.FC<HighlightProps> = ({ highlight, attribute, hit }) => {
  const { isFocusedOnSearch } = useProducts();

  const parsedHit = highlight({
    highlightProperty: '_highlightResult',
    attribute,
    hit,
  });

  return (
    <Styles.Highlight>
      <Text.caption2
        color={isFocusedOnSearch ? defaultTheme.colors.secondaryGrey : defaultTheme.colors.deepBlue}
      >
        {parsedHit.map((part, index) =>
          part.isHighlighted ? (
            <mark key={index}>{part.value}</mark>
          ) : (
            <span key={index}>{part.value}</span>
          ),
        )}
      </Text.caption2>
    </Styles.Highlight>
  );
};

export const Highlight = connectHighlight(ConnectedHighlight);
